import { createSlice } from '@reduxjs/toolkit';
import appTypes from '../app/types';
const initialState = {
    company: null,
    employees: [],
    employeeIds: [],
    currentEmployeeId: null,
    requestId: null,
    maskId: null,
    sessionId: null,
    moreResults: false,
};
const slice = createSlice({
    name: 'COMPANY',
    initialState,
    extraReducers(builder) {
        builder.addCase(appTypes.RESET, () => initialState);
    },
    reducers: {
        setSearchEmployeesResult(state, { payload }) {
            var _a, _b, _c, _d, _e, _f;
            state.company = (_a = payload.company) !== null && _a !== void 0 ? _a : null;
            state.employees = (_b = payload.contacts) !== null && _b !== void 0 ? _b : [];
            // Filled by the dispatcher once the employees are mapped into `state.contacts`.
            state.employeeIds = [];
            state.currentEmployeeId = null;
            state.requestId = (_c = payload.requestId) !== null && _c !== void 0 ? _c : null;
            state.maskId = (_d = payload.maskId) !== null && _d !== void 0 ? _d : null;
            state.sessionId = (_e = payload.sessionId) !== null && _e !== void 0 ? _e : null;
            // Absent means "assume there is more" — as the removed MST `setSearchMetadataResult` defaulted.
            state.moreResults = (_f = payload.moreResults) !== null && _f !== void 0 ? _f : true;
        },
        setInvalidateStatus(state, { payload }) {
            state.invalidated = payload;
        },
        setEmployeeIds(state, { payload }) {
            state.employeeIds = payload;
        },
        setCurrentEmployeeId(state, { payload }) {
            state.currentEmployeeId = payload;
        },
        /**
         * Drops the employee list but keeps the company.
         * Used when re-running a search with different filters or free text.
         */
        clearEmployees(state) {
            state.employees = [];
            state.employeeIds = [];
            state.currentEmployeeId = null;
        },
        clearSearchEmployeesResult() {
            return initialState;
        },
    },
});
export const { reducer, actions } = slice;
export default reducer;
